import { useTranslator } from '@Localization';
import { MenuItem } from '@mui/joy';
import { useInjection } from 'inversify-react';
import { observer } from 'mobx-react-lite';
import { ReactElement } from 'react';
import { EditIcon } from '../../../../../design/static/icons/EditIcon';
import { useAttachmentsPermissions } from '../../../Attachments.permissions';
import { IRenameAttachmentBl } from '../../RenameAttachment.bl';
interface IProps {
  id: string;
  name: string;
  parentId: string | undefined;
}

export const RenameAttachmentMenuItemContainer = observer((props: IProps): ReactElement => {
  const bl = useInjection(IRenameAttachmentBl.$);
  const permissions = useAttachmentsPermissions();
  const { t } = useTranslator();
  const canRename = permissions.canRenameAttachment();

  const handleClick = (): void => {
    bl.initialize(props.id, props.name, props.parentId);
    bl.showModal();
  };

  return (
    <MenuItem
      disabled={!canRename.allowed}
      onClick={handleClick}
      title={canRename.reason}
    >
      <EditIcon /> {t('attachments.rename_attachment')}
    </MenuItem>
  );
});
